module.exports = __webpack_public_path__ + "img/blackcatonly72.0d34706a.png";